export const darkModeBlack = "#0A1414";
export const lightGray = "#e8eaed";
export const dark = "#202124";
